export function getDisplayName(args) {
  return {
    type: 'edit',
    path: args.path,
    find: args.find,
    replace: args.replace
  };
}
